var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-carousel', {
    staticClass: "main-slide",
    attrs: {
      "height": "auto",
      "hide-delimiters": "",
      "show-arrows-on-hover": "",
      "cycle": _vm.cycle
    },
    model: {
      value: _vm.model,
      callback: function callback($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }, _vm._l(_vm.banners, function (banner, index) {
    return _c('v-carousel-item', {
      key: index,
      attrs: {
        "ripple": false
      }
    }, [banner.open ? _c('v-img', {
      attrs: {
        "src": banner.image,
        "width": "100%",
        "contain": "",
        "aspect-ratio": 640 / 820
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.$emit('open', banner.open);
        }
      }
    }) : _vm._e(), banner.to ? _c('router-link', {
      attrs: {
        "to": banner.to
      }
    }, [_c('v-img', {
      attrs: {
        "src": banner.image,
        "width": "100%",
        "contain": "",
        "aspect-ratio": 640 / 820
      }
    })], 1) : _vm._e(), !banner.to && !banner.open ? _c('v-img', {
      attrs: {
        "src": banner.image,
        "width": "100%",
        "contain": "",
        "aspect-ratio": 640 / 820
      }
    }) : _vm._e()], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }